import React from "react";
import { useRouter } from "next/router";
import styles from "./ElixirImproves.module.scss";
import { ELIXIR_URL } from "@/constastants/Constant";
import { appendUtmParams, resolveUtmParams } from "@/utils/utmParams";

const ICON_BASE = "/assets/icons/elchemy-tech";

const CARDS = [
  {
    icon: `${ICON_BASE}/benefit-dots.svg`,
    title: "No More Chasing Updates",
    body: "Buyers, manufacturers, and distributors track every stage themselves. From enquiry confirmation to delivery milestone, without emailing or calling a supplier once. AI for supply chain visibility does the work.",
  },
  {
    icon: `${ICON_BASE}/benefit-bolt.svg`,
    title: "Faster Decisions, Less Back-And-Forth",
    body: "Complete product data and live AI pricing eliminate the discovery loop entirely. Chemical buyers evaluate, enquire, and confirm, all within the same platform session. Technology built for manufacturing speed.",
  },
  {
    icon: `${ICON_BASE}/benefit-cube.svg`,
    title: "Compliance Confidence",
    body: "Elixir's AI technology keeps every compliance document, certificate, and regulatory requirement tracked and accessible. Chemical manufacturers and distributors meet industry standards without the manual overhead.",
  },
  {
    icon: `${ICON_BASE}/benefit-shield.svg`,
    title: "Quality Assurance Before Transit",
    body: "AI-enabled stuffing images let QA teams visually verify labelling, packing, and product condition before the container is sealed. Catch chemical manufacturing issues before they become costly claims",
  },
];

function ElixirImproves() {
  const router = useRouter();

  const handleExploreElixir = () => {
    const utm = resolveUtmParams(router.query, { source: "website", medium: "elixir_page" });
    window.open(appendUtmParams(ELIXIR_URL, utm), "_blank", "noopener,noreferrer");
  };

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        {/* Left: benefit cards + CTA */}
        <div className={styles.cards}>
          {CARDS.map((card, i) => (
            <article className={styles.card} key={i}>
              <img src={card.icon} alt="" className={styles.icon} />
              <div className={styles.cardText}>
                <h3 className={styles.cardTitle}>{card.title}</h3>
                <p className={styles.cardBody}>{card.body}</p>
              </div>
            </article>
          ))}

          <button
            type="button"
            className={styles.cta}
            onClick={handleExploreElixir}
          >
            Explore Elixir
          </button>
        </div>

        {/* Right: decorative paths + centered heading */}
        <div className={styles.decor}>
          <span className={styles.glow} aria-hidden="true" />
          <img
            src={`${ICON_BASE}/improves-paths.svg`}
            alt=""
            aria-hidden="true"
            className={styles.paths}
          />
          <h2 className={styles.decorHeading}>
            How Elixir&apos;s AI Improves The Chemical Industry Experience
          </h2>
        </div>
      </div>
    </section>
  );
}

export default ElixirImproves;
